export default __webpack_public_path__ + "static/media/White-Render-Square-removebg-desktop.9e9252ff.png";